import { bkkMapCenter, macauMapCenter } from 'configs/variables';
import { toJS } from 'mobx';
import UserStore from 'mobx/UserStore';
import { useMemo } from 'react';

export function useMapsCenter() {
  const centered = useMemo(() => {
    const locations = toJS(UserStore.organization.location);
    const hasLocations = locations?.coordinates?.filter((x) => x)?.length > 1 || false;
    if (hasLocations) {
      const coordinates = locations?.coordinates.reverse();
      const t = { lat: coordinates?.[0], lng: coordinates?.[1] };
      return t;
    } else {
      return UserStore.organization?.short_name_en === 'MC' ? macauMapCenter : bkkMapCenter;
    }
  }, []);

  return {
    centered,
  };
}
